import classNames from "classnames";
import React, { useState, useCallback, useEffect, useMemo, Fragment, useRef } from "react";
// import placeholderImg from "../images/placeholder.png";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import Slider from "react-slick";
import { eventPdpSliderSlide } from "../utility/datalayer";
import LightboxModal from "./lightbox-modal";
import Enlarge from "../icons/enlarge.svg";
import sizeDiagram from "../images/size_diagram.png";
import { matchBreakpoint } from "../hooks/use-is-mobile";

const settingsZoom = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  dots: false,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: false,
        arrows: true,
      },
    },
  ],
};

const TechnicalSpecifications = ({
  data,
  scrollRef,
  labelManagerLabels,
  otherDesign,
  hasWifiManual,
  otherFull,
  imgTitle,
  checkPdpConnectivityMessage,
}) => {
  const [openTabAccordion, setOpenTabAccordion] = useState(0);
  const [scrollElem, setScrollElem] = useState(null);
  const toggleItem = useCallback((e) => {
    const clickIdx = parseInt(e.target.name);
    setOpenTabAccordion((value) => (clickIdx === value ? -1 : clickIdx));
  }, []);
  const toggleItemMobile = useCallback(
    (e) => {
      const clickIdx = parseInt(e.target.name);
      setScrollElem({
        elem: e.target,
        name: clickIdx,
      });
      toggleItem(e);
    },
    [toggleItem]
  );

  const dimensionsRef = useRef();
  const dimensionsRefButton = useRef();

  // Sul mobile, scrolla all'elemento selezionato
  useEffect(() => {
    if (scrollElem && scrollElem.name === openTabAccordion && scrollRef.current) {
      const { top: anchorTop, height: anchorHeight } = scrollRef.current.getBoundingClientRect();
      const { top } = scrollElem.elem.getBoundingClientRect();
      const scrollPos = document.body.scrollTop || document.documentElement.scrollTop;
      window.scrollTo({ top: scrollPos + top - (anchorTop + anchorHeight), behavior: "smooth" });
      setScrollElem(null);
    }
  }, [scrollRef, openTabAccordion, scrollElem]);

  const designImages = useMemo(() => {
    // const imagesThumb = otherDesign?.find((images) =>
    //   images?.some((image) => image?.imageUrl?.includes("_n_"))
    // );
    const imagesFull = otherFull?.filter((images) =>
      images?.some((image) => image?.imageUrl?.includes("_n_"))
    );
    // const thumb =
    //   imagesThumb?.find((item) => item.imageType === "M" && item.imageUrl?.includes("_n_")) ||
    //   placeholderImg;
    const full = imagesFull?.map((item) =>
      item.find((item) => item.imageType === "M" && item.imageUrl?.includes("_n_"))
    );
    return {
      // thumb,
      full,
    };
  }, [otherFull]);

  const enhanced = false;

  const settingsZoomSlider = useMemo(
    () => ({
      ...settingsZoom,
      beforeChange: (prev, next) => {
        if (prev !== next) {
          eventPdpSliderSlide({
            type: "modal",
            slide: next,
            enhanced,
          });
        }
      },
    }),
    [enhanced]
  );

  const [zoom, setZoom] = useState(false);
  const showZoom = () => {
    setZoom(true);
  };
  const closeZoom = () => setZoom(false);

  const dimensionsIndex = data?.findIndex((item) => item?.category?.id === 99);
  useEffect(() => {
    const openDimensionsListener = () => {
      if (dimensionsIndex !== undefined && dimensionsIndex >= 0) {
        setOpenTabAccordion(dimensionsIndex);
        const option = {
          root: null,
          rootMargin: "20px",
          threshold: 0,
        };
        if (matchBreakpoint(767)) {
          const observer = new IntersectionObserver(function (entries) {
            const target = entries[0];
            if (target.isIntersecting) {
              if (dimensionsRefButton.current) {
                setScrollElem({
                  elem: dimensionsRefButton.current,
                  name: dimensionsIndex,
                });
              }
              observer.disconnect();
            }
          }, option);
          observer.observe(dimensionsRef.current);
        }
      }
    };
    document.addEventListener("open-dimensions", openDimensionsListener);
    return () => {
      document.removeEventListener("open-dimensions", openDimensionsListener);
    };
  }, [dimensionsIndex, toggleItem]);

  return (
    <section className="section">
      <div className="container-fluid">
        <h2 ref={dimensionsRef} className="section__title pt-2 mb-4">
          {labelManagerLabels.technicalSpecifications}
        </h2>
        <div
          className={classNames(
            "technical-spec__wrapper",
            data?.length === 1 && "technical-spec__wrapper--single-item"
          )}
        >
          <div className={classNames("row", data?.length === 1 && "justify-content-center")}>
            {data?.length > 1 && (
              <div className="col-12 col-md-5 pr-md-0">
                <div className="technical-spec">
                  {data.map((item, i) => (
                    <div
                      className={`technical-spec__box${openTabAccordion === i ? " open" : ""}`}
                      key={i}
                    >
                      <h4 className="technical-spec__title d-none d-md-block">
                        <button onClick={toggleItem} name={i}>
                          {item.category.nameCategory}
                        </button>
                      </h4>
                      <h4 className="technical-spec__title d-md-none">
                        <button
                          ref={item?.category?.id === 99 ? dimensionsRefButton : null}
                          onClick={toggleItemMobile}
                          name={i}
                        >
                          {item.category.nameCategory}
                        </button>
                      </h4>
                      <div className="technical-spec__content d-md-none">
                        <div className="w-100">
                          {designImages &&
                            designImages?.full &&
                            designImages?.full?.length > 0 &&
                            item?.category?.id === 99 && (
                              <div className="technical-spec__content">
                                <div className="technical-spec__img-wrapper">
                                  <button className="technical-spec__img-button" onClick={showZoom}>
                                    <Enlarge className="technical-spec__icon" />
                                    <img
                                      src={sizeDiagram}
                                      alt="size-diagram"
                                      className="technical-spec__img slider-img-prod__img"
                                    />
                                    <div className="technical-spec__img-label">
                                      {labelManagerLabels.seeSizeDiagram}
                                    </div>
                                  </button>
                                </div>
                                <LightboxModal
                                  show={zoom}
                                  onHide={closeZoom}
                                  noCloseSelector=".slick-arrow"
                                >
                                  <Slider {...settingsZoomSlider} className="slider-zoom-img-prod">
                                    {designImages.full.map((designImage, i) => (
                                      <Fragment key={i}>
                                        {typeof designImage === "string" ? (
                                          <img
                                            src={designImage}
                                            alt={imgTitle}
                                            className="slider-zoom-img-prod__img"
                                          />
                                        ) : (
                                          <GatsbyImage
                                            image={getImage(designImage)}
                                            alt={imgTitle}
                                            className="slider-zoom-img-prod__img"
                                            objectFit="contain"
                                          />
                                        )}
                                      </Fragment>
                                    ))}
                                  </Slider>
                                </LightboxModal>
                              </div>
                            )}
                          {item.children &&
                            item.children.map((child, j) => (
                              <div className="technical-spec__row" key={j}>
                                <div className="row">
                                  <div className="col-md-8 font-light">{child.fieldName}</div>
                                  <div className="col-md-4 font-regular">
                                    {child.fieldBoolean && child.fieldValue === "1"
                                      ? labelManagerLabels.yes
                                      : child.fieldBoolean && child.fieldValue === "0"
                                      ? labelManagerLabels.no
                                      : child.fieldValue || "-"}
                                  </div>
                                </div>
                              </div>
                            ))}
                          {(item.category.id === 176 || item.category.id === 9) && hasWifiManual && (
                            <div className="technical-spec__row">
                              <div className="row">
                                <div className="col-md-8 font-light">
                                  <a href={hasWifiManual.filename} target="_blank" rel="noreferrer">
                                    {labelManagerLabels.wifi50711Manual}
                                  </a>
                                </div>
                                <div className="col-md-4 font-regular"></div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {data.map((item, i) => (
              <div
                className={classNames(
                  `col-7 d-none${
                    openTabAccordion === i
                      ? " d-md-flex justify-content-center align-items-center"
                      : ""
                  }`,
                  designImages &&
                    designImages?.full &&
                    designImages?.full?.length &&
                    item?.category?.id === 99 &&
                    "flex-column"
                )}
                key={i}
              >
                {designImages &&
                  designImages?.full &&
                  designImages?.full?.length > 0 &&
                  item?.category?.id === 99 && (
                    <div className="technical-spec__content">
                      <div className="technical-spec__img-wrapper">
                        <button className="technical-spec__img-button" onClick={showZoom}>
                          <Enlarge className="technical-spec__icon" />
                          <img
                            src={sizeDiagram}
                            alt="size-diagram"
                            className="technical-spec__img slider-img-prod__img"
                          />
                          <div className="technical-spec__img-label">
                            {labelManagerLabels.seeSizeDiagram}
                          </div>
                        </button>
                      </div>
                      <LightboxModal show={zoom} onHide={closeZoom} noCloseSelector=".slick-arrow">
                        <Slider {...settingsZoomSlider} className="slider-zoom-img-prod">
                          {designImages.full.map((designImage, i) => (
                            <Fragment key={i}>
                              {typeof designImage === "string" ? (
                                <img
                                  src={designImage}
                                  alt={imgTitle}
                                  className="slider-zoom-img-prod__img"
                                />
                              ) : (
                                <GatsbyImage
                                  image={getImage(designImage)}
                                  alt={imgTitle}
                                  className="slider-zoom-img-prod__img"
                                  objectFit="contain"
                                />
                              )}
                            </Fragment>
                          ))}
                        </Slider>
                      </LightboxModal>
                    </div>
                  )}

                <div className="technical-spec__content">
                  {item.children &&
                    item.children.map((child, j) => (
                      <div className="technical-spec__row" key={j}>
                        <div className="row">
                          <div className="col-md-8 font-light">{child.fieldName}</div>
                          <div className="col-md-4 font-regular">
                            {child.fieldBoolean && child.fieldValue === "1"
                              ? labelManagerLabels.yes
                              : child.fieldBoolean && child.fieldValue === "0"
                              ? labelManagerLabels.no
                              : child.fieldValue || "-"}
                          </div>
                        </div>
                      </div>
                    ))}
                  {(item.category.id === 176 || item.category.id === 9) && hasWifiManual && (
                    <div className="technical-spec__row">
                      <div className="row">
                        <div className="col-md-8 font-light">
                          <a href={hasWifiManual.filename} target="_blank" rel="noreferrer">
                            {labelManagerLabels.wifi50711Manual}
                          </a>
                        </div>
                        <div className="col-md-4 font-regular"></div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {checkPdpConnectivityMessage && (
        <div
          className="technical-spec__pdp-connectivity-message"
          dangerouslySetInnerHTML={{ __html: labelManagerLabels.pdpLegalSentence }}
        ></div>
      )}
    </section>
  );
};

export default TechnicalSpecifications;
